import React, { useState } from 'react'
import { Tabs } from 'antd'
import BuscarPorTextoTab from './BuscarPorTextoTab'
import BuscarPorImagenTab from './BuscarPorImagenTab'
import './AxiomaReemplazantesContainer.css'

const AxiomaReemplazantesContainer = () => {
  const [activeTab, setActiveTab] = useState('texto')

  const tabItems = [
    {
      key: 'texto',
      label: 'Buscar por texto',
      children: <BuscarPorTextoTab />,
    },
    {
      key: 'imagen',
      label: 'Buscar por imagen',
      children: <BuscarPorImagenTab />,
    },
  ]

  return (
    <div className="reemplazantes-container">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        className="reemplazantes-tabs"
      />
    </div>
  )
}

export default AxiomaReemplazantesContainer
